/**
 * Endereço público de contato.
 *
 * O frontend anunciava três endereços diferentes — `support@` no formulário de
 * contato, `privacy@` na política e `legal@` nos termos — e nenhum dos três
 * existe. A caixa que de fato recebe é a do `CONTACT_INBOX` do backend
 * (`services/mailer.js`), que é para onde o formulário entrega.
 *
 * Escrever a alguém num endereço que ninguém lê é pior do que não oferecer
 * endereço nenhum: a pessoa acha que pediu exclusão de dados e fica esperando.
 *
 * Se um dia houver caixas separadas por assunto, elas entram aqui e as telas
 * seguem — o problema anterior era o endereço estar digitado em cada arquivo.
 */
export const EMAIL_DE_CONTATO = 'contact@silentpuma.com';

/** O remetente é outro: `no-reply@updates.silentpuma.com`, no subdomínio
 *  verificado no Resend. Não é caixa de entrada e não deve ser publicado. */
